<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";

    export default {
        name: "TestDrivePointDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    address: "",
                    city: "",
                    latitude: "",
                    longitude: "",
                },
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить точку",
                    view: "Точка",
                    edit: "Редактировать точку",
                };
                return filtered[this.statusPage];
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
        },
        methods: {
            send() {
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "TestDrivePointEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.$store.autoAdminApi
                    .editTestDrivePoint(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "TestDrivePoints",
                        });
                    });
            },
            handlerForCreate() {
                this.$store.autoAdminApi.createTestDrivePoint(this.form).then(({ data }) => {
                    this.$router.push({
                        name: "TestDrivePointView",
                        params: {
                            slug: data.id,
                        },
                    });
                });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi
                    .getTestDrivePoint(this.$route.params.slug)
                    .then(({ data }) => {
                        this.form = data;
                    });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="vendor-detail">
        <the-detail-wrapper
            :title="title"
            type-list="/testdrive-points"
            :current-status="statusPage"
            @handler-submit="send"
        >
            <b-field label="Город">
                <b-input v-model="form.city"></b-input>
            </b-field>
            <b-field label="Адрес">
                <b-input v-model="form.address"></b-input>
            </b-field>
            <b-field label="Широта">
                <b-input v-model.number="form.latitude"></b-input>
            </b-field>
            <b-field label="Долгота">
                <b-input v-model.number="form.longitude"></b-input>
            </b-field>
        </the-detail-wrapper>
    </div>
</template>

<style lang="scss"></style>
